var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPalletInternational(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 24c-3.584 0-6.5-2.916-6.5-6.5s2.916-6.5 6.5-6.5 6.5 2.916 6.5 6.5-2.916 6.5-6.5 6.5zm0-12c-3.033 0-5.5 2.468-5.5 5.5s2.467 5.5 5.5 5.5 5.5-2.468 5.5-5.5-2.467-5.5-5.5-5.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 23.65a.5.5 0 01-.5-.5v-11.3a.5.5 0 011 0v11.3a.5.5 0 01-.5.5zM19.5 23.65a.5.5 0 01-.5-.5v-11.3a.5.5 0 011 0v11.3a.5.5 0 01-.5.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.15 16h-11.3a.5.5 0 010-1h11.3a.5.5 0 010 1zM23.15 20h-11.3a.5.5 0 010-1h11.3a.5.5 0 010 1zM10.007 10.5a.5.5 0 01-.224-.947l9.494-4.75A.5.5 0 0120 5.25V9.5a.5.5 0 01-1 0V6.059l-8.77 4.388a.497.497 0 01-.223.053z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 20a.512.512 0 01-.242-.062l-9-5A.502.502 0 010 14.5V5.25a.5.5 0 01.723-.447l9.494 4.75a.5.5 0 01-.447.895L1 6.059v8.147l8.743 4.856A.5.5 0 019.5 20z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 5.75a.497.497 0 01-.223-.053L9.994 1.059.724 5.697a.501.501 0 01-.448-.894L9.77.053a.502.502 0 01.447 0l9.506 4.75a.5.5 0 01-.223.947z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.043 11.739a.5.5 0 01-.5-.5V7.521a.5.5 0 01.276-.447l9.494-4.75a.5.5 0 01.447.895L5.543 7.831v3.409a.499.499 0 01-.5.499z"
  })));
}

export default SvgPalletInternational;